// extracted by mini-css-extract-plugin
export default {"sweat":"arena_sweat__Hd5-9","timer":"arena_timer__6SZ0b","timer2":"arena_timer2__7kY8N","timer_container":"arena_timer_container__C0HJs"};